export enum UserRoleEnum {
  ExternalUser = 'External User',
  GstarAdmin = 'Gstar Admin',
  SystemAdmin = 'System Admin',
  CountryAdmin = 'Country Admin',
}
